<template>
  <div class="SubSectionInverters">
    <h3 class="title">
      {{ $t('title') }}
    </h3>
    <Row>
      <Column v-for="(inverter, index) in inverters" :key="index" :sm="6" :xs="12">
        <!-- <ColumnModule logoBrandSrc="../../../../../assets/quipment/modules/znShine-logo.png" /> -->
        <ColumnInverter :inverter="inverter" />
      </Column>
    </Row>
  </div>
</template>

<script>
import ColumnInverter from './ColumnInverter'

export default {
  components: {
    ColumnInverter,
  },
  data() {
    return {
      inverters: [
        {
          themeColor: '#4dbeed',
          logo: require('@/assets/quipment/inverters/solaredge-logo.png'),
          inverterPic: require('@/assets/quipment/inverters/solaredge-inverter.png'),
          intro: 'SolarEdge – išmani (optimizuota saulės elektrinė)',
          pros: [
            {
              icon: require('@/assets/quipment/inverters/icons/25percent.png'),
              label: 'Sugeneruoja iki 25% daugiau energijos',
              value: 'Kiekvienas modulis nepriklauso vienas nuo kito ir tokiu būdu išgaunama maksimali galia iš kiekvieno modulio',
            },
            {
              icon: require('@/assets/quipment/inverters/icons/monitoring.png'),
              label: 'Pilnas sistemos stebėjimas',
              value: 'Galite realiu laiku mobiliajame telefone stebėti kiekvieno modulio veikimą atskirai. Moduliui sugedus, sistema parodys, kuri dalis yra pažeista',
            },
            {
              icon: require('@/assets/quipment/inverters/icons/guarantee.png'),
              label: 'Garantijos',
              value: '25 metų garantija optimizatoriams ir 12 metų garantija inverteriams',
            },
            {
              icon: require('@/assets/quipment/inverters/icons/safety.png'),
              label: 'Papildomas saugumas',
              value: 'Automatinis DC srovės išjungimas apsaugo montuotojus, ugniagesius ir kitus asmenis pavojaus atveju. SolarEdge inverteris - vienintelis, atitinkantis Europos saugumo standartus',
            },
            {
              icon: require('@/assets/quipment/inverters/icons/roof-efficiency.png'),
              label: 'Efektyvus stogo išnaudojimas',
              value: 'Galimybė išnaudoti skirtingų orientacijų stogus bei montuoti modulius ant įvairių stogų tipų',
            },
          ],
        },
        {
          themeColor: '#734bdc',
          logo: require('@/assets/quipment/inverters/goodwe-logo.png'),
          inverterPic: require('@/assets/quipment/inverters/goodwe-inverter.png'),
          intro: 'Goodwe – tradicinė įranga',
          pros: [
            {
              icon: require('@/assets/quipment/inverters/icons/percent.svg'),
              label: 'Efektyvumas',
              value: 'Inverterio efektyvumas – 98.4%',
            },
            {
              icon: require('@/assets/quipment/inverters/icons/monitoring.png'),
              label: 'Stebėjimas',
              value: 'Galimybė stebėti generuojamą galią per mobiliąją programėlę',
            },
            {
              icon: require('@/assets/quipment/icons/weight.svg'),
              label: 'Svoris',
              value: 'Inverterio svoris 25 kg',
            },
            // {
            //   icon: require('@/assets/quipment/inverters/icons/water.svg'),
            //   label: 'Atsparumas korozijai',
            //   value: 'Didelis antikorozinis lygis (C5)',
            // },
            {
              icon: require('@/assets/quipment/inverters/icons/safety.png'),
              label: 'Apsauga',
              value: 'Įmontuota viršįtampių apsauga (DC Type III / AC Type III)',
            },
            {
              icon: require('@/assets/quipment/inverters/icons/guarantee.png'),
              label: 'Garantija',
              value: 'Produkto garantija - 10 metų',
            },
          ],
        },
        // {
        //   themeColor: '#734bdc',
        //   logo: require('@/assets/quipment/inverters/sungrow-logo.png'),
        //   inverterPic: require('@/assets/quipment/inverters/sungrow-inverter.png'),
        //   intro: 'Sungrow – TOP 5 inverterio gamintojas pasaulyje',
        //   pros: [
        //     {
        //       icon: require('@/assets/quipment/inverters/icons/percent.svg'),
        //       label: 'Efektyvumas',
        //       value: 'Inverterio efektyvumas – 98.6%',
        //     },
        //     {
        //       icon: require('@/assets/quipment/inverters/icons/monitoring.png'),
        //       label: 'Stebėjimas',
        //       value: 'Galimybė stebėti našumą per mobilią aplikaciją arba internetinę svetainę su papildomu priedėliu',
        //     },
        //     {
        //       icon: require('@/assets/quipment/icons/weight.svg'),
        //       label: 'Svoris',
        //       value: 'Inverterio svoris 20 kg',
        //     },
        //     {
        //       icon: require('@/assets/quipment/inverters/icons/water.svg'),
        //       label: 'Atsparumas korozijai',
        //       value: 'Didelis antikorozinis lygis (C5)',
        //     },
        //     {
        //       icon: require('@/assets/quipment/inverters/icons/safety.png'),
        //       label: 'Apsauga',
        //       value: 'Įmontuota viršįtampių apsauga (DC Type II / AC Type II)',
        //     },
        //     {
        //       icon: require('@/assets/quipment/inverters/icons/guarantee.png'),
        //       label: 'Garantija',
        //       value: 'Produkto garantija - 10 metų',
        //     },
        //   ],
        // },
      ],
    }
  },
  computed: {
  },
}
</script>

<style lang="scss">
.SubSectionInverters {
  margin-bottom: 6rem;

  .title {
    color: $main;
    font-size: 2rem;
    font-weight: $bold;
    // padding-bottom: 3rem;
    text-align: center;
  }

}
</style>
<i18n>
{
  "lt": {
    "title": "Inverteriai (Įtampos keitikliai)"
  }
}
</i18n>
